import * as React from "react";
import { cn } from "@/lib/utils";

interface PageWrapperProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}

export function PageWrapper({
  children,
  className,
  fullWidth = false,
}: PageWrapperProps) {
  return (
    <div
      className={cn(
        "min-h-screen bg-[#ffffff]",
        !fullWidth && "max-w-7xl",
        className
      )}
    >
      {children}
    </div>
  );
}

export default PageWrapper;
